import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../components/ui/sheet";
import { Button } from "../components/ui/button";
import { useCart, lineDetails } from "../lib/cart";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { absUrl } from "../lib/api";
import { useNavigate } from "react-router-dom";

export default function CartSheet({ open, onOpenChange }) {
  const { items, inc, dec, remove, subtotal } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-md flex flex-col p-0" data-testid="cart-sheet">
        <SheetHeader className="px-5 pt-5">
          <SheetTitle className="font-display text-xl flex items-center gap-2">
            <ShoppingBag size={20} className="text-[#CC1A00]" />
            Your Order
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3">
          {items.length === 0 && (
            <div data-testid="empty-cart" className="text-center text-gray-500 py-12">
              <ShoppingBag className="mx-auto mb-3 text-gray-300" size={36} />
              Your cart is empty. Add some tasty dishes!
            </div>
          )}
          {items.map((i) => (
            <div key={i.key} data-testid="cart-line" className="flex items-center gap-3 bg-white rounded-xl p-2 border border-gray-100">
              <div className="h-14 w-14 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
                {i.image_url && <img src={absUrl(i.image_url)} alt={i.name} className="h-full w-full object-cover" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm text-gray-900 line-clamp-2">{i.name}</div>
                {lineDetails(i) && <div className="text-[11px] text-gray-500">{lineDetails(i)}</div>}
                <div className="text-xs text-[#CC1A00] font-bold">KSh {i.price * i.quantity}</div>
              </div>
              <div className="flex items-center gap-1.5">
                <button onClick={() => dec(i.key)} className="h-7 w-7 rounded-full bg-[#FFF1EE] text-[#CC1A00] grid place-items-center" data-testid={`cart-dec-${i.key}`}><Minus size={12} /></button>
                <span className="w-6 text-center text-sm font-semibold">{i.quantity}</span>
                <button onClick={() => inc(i.key)} className="h-7 w-7 rounded-full mlobox-gradient text-white grid place-items-center" data-testid={`cart-inc-${i.key}`}><Plus size={12} /></button>
                <button onClick={() => remove(i.key)} className="h-7 w-7 rounded-full bg-gray-100 text-gray-500 grid place-items-center ml-1" data-testid={`cart-remove-${i.key}`}><Trash2 size={12} /></button>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-gray-100 p-5 space-y-3 bg-white">
            <div className="flex justify-between text-base"><span className="font-semibold">Subtotal</span><span data-testid="cart-total" className="font-extrabold text-[#CC1A00]">KSh {subtotal}</span></div>
            <p className="text-xs text-gray-500">Delivery fee is added at checkout once you set your location.</p>
            <Button
              data-testid="checkout-btn"
              onClick={() => { onOpenChange(false); navigate("/checkout"); }}
              className="w-full mlobox-gradient text-white font-semibold rounded-full py-6 hover:brightness-110 shadow-md"
            >
              Proceed to Checkout
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
